<template>
  <div class="content" style="user-select: none;">
    <!-- Hero Section with Banner -->
    <div class="top-swiper" style="box-shadow: 0 20px 10px rgba(0, 0, 0, 0.2);" @click="scrollDown">
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div v-for="(item, index) in swiperList" :key="index" class="swiper-slide">
            <div class="swiper-li">
              <img style="max-height: 40vw;min-height: 40vw;cursor: pointer;" :src="item.img" class="img-swiper" alt="" />
            </div>
          </div>
        </div>
        <div class="swiper-pagination"></div>
      </div>
    </div>

    <!-- About Us Section -->
    <div id="historyId" class="company-history width1600" ref="fadeEnlarge">
      <div class="history-container">
        <div class="history-left" @click="clickGoin">
          <img src="@/assets/img1/深圳市达通源科技有限公司LOG.jpg" alt="">
        </div>
        <div class="history-right">
          <h3 class="history-h3" style="color:black;user-select: none">关于我们</h3>
          <p class="history-p" style="user-select: none;">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;深圳市达通源科技有限公司，简称DTY，是国家认可的第三方检测机构。公司创立于2013年6月，依法注册取得工商营业执照，是一家具有独立法人的企业，主要致力于节水、节能等领域，为市场提供专业的检测、技术、咨询等服务。
            <br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;经营范围主要包括：水量平衡测试、能源审计、能效检测、节能量审核、节能规划、能效（水效）对标、绿色工厂、绿色物业、节水型载体创建、节水节能改造及检测、节水节能宣传培训、节约型机关创建、合同能源管理、能源计量审查、碳核查、能源计量器具配备和管理、碳计量技术咨询、能源管理体系、测量管理体系、测量保证体系咨询和培训等。
          </p>
          <div class="more" @click="clickGoin">
            详情
          </div>
        </div>
      </div>
    </div>

    <!-- Key Features Section -->
    <div class="features-section">
      <div class="section-container">
        <div class="section-header">
          <h2>我们的优势</h2>
          <p>专业的技术团队，完善的服务体系</p>
        </div>
        <div class="features-grid">
          <div v-for="(item, index) in companyCultureList" :key="index" class="feature-card">
            <div class="feature-icon">
              <img :src="item.img" :alt="item.subtilte">
            </div>
            <h3>{{ item.subtilte }}</h3>
            <p>{{ item.text }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Services Section -->
    <div class="service-section">
      <div class="section-header">
        <h2>我们的服务</h2>
        <p>OUR SERVICES</p>
      </div>
      <div class="service-grid">
        <div class="service-card" v-for="(service, index) in services" :key="index" @click="routeLink(service.id)">
          <div class="card-image">
            <img :src="service.filePath" :alt="service.name">
            <div class="card-overlay">
              <div class="overlay-content">
                <h3>{{ service.name }}</h3>
                <span class="view-more">查看详情</span>
              </div>
            </div>
          </div>
          <div class="card-content">
            <h3>{{ service.name }}</h3>
            <div class="card-line"></div>
            <!-- <div class="card-description" v-html="getShortDescription(service.description)"></div> -->
            <div class="card-description">{{ service.content }}</div>
          </div>
        </div>
      </div>
      <div class="view-all">
        <router-link to="/product" class="view-all-btn">查看全部服务</router-link>
      </div>
    </div>

    <!-- Statistics Section -->
    <div class="stats-section">
      <div class="section-container">
        <div class="stats-grid">
          <div class="stat-item">
            <h3>10+</h3>
            <p>年行业经验</p>
          </div>
          <div class="stat-item">
            <h3>1000+</h3>
            <p>服务客户</p>
          </div>
          <div class="stat-item">
            <h3>100+</h3>
            <p>标杆项目</p>
          </div>
          <div class="stat-item">
            <h3>100%</h3>
            <p>客户满意度</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Contact Section -->
    <div class="contact-section">
      <div class="section-container">
        <div class="section-header">
          <h2>联系我们</h2>
          <p>期待与您的合作</p>
        </div>
        <div class="contact-content">
          <div class="contact-info">
            <div class="info-card">
              <div class="icon-box">
                <i class="el-icon-location"></i>
              </div>
              <h3>公司地址</h3>
              <p>深圳市光明区公明街道上村社区长春北路1A栋301</p>
            </div>
            <div class="info-card">
              <div class="icon-box">
                <i class="el-icon-phone"></i>
              </div>
              <h3>联系电话</h3>
              <p>0755-88608260</p>
              <p>19842675889</p>
            </div>
            <div class="info-card">
              <div class="icon-box">
                <i class="el-icon-message"></i>
              </div>
              <h3>在线咨询</h3>
              <p>欢迎随时与我们联系</p>
              <button class="contact-btn" @click="showContactDialog">立即咨询</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ContactUs ref="contactUs" />
  </div>
</template>

<style lang="less" scoped>
// 全局样式
.section-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
}

.section-header {
  text-align: center;
  margin-bottom: 60px;
  
  h2 {
    font-size: 2.5rem;
    color: #2c3e50;
    margin-bottom: 15px;
  }
  
  p {
    font-size: 1.2rem;
    color: #2c3e50;
  }
}

// Hero Section
.top-swiper {
  .swiper-container {
    .swiper-wrapper {
      max-height: 40vw !important;

      .swiper-slide {
        .swiper-li {
          .img-swiper {
            width: 100%;
            vertical-align: bottom;
          }
        }
      }
    }

    .swiper-pagination {
      /deep/ .swiper-pagination-bullet {
        background-color: #fff;
      }

      /deep/ .swiper-pagination-bullet-active {
        background-color: #409EFF;
      }
    }
  }
}

// Features Section
.features-section {
  padding: 100px 0;
  background: linear-gradient(to bottom, #ffffff, #f8f9fa);
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 60px;
    height: 3px;
    background: linear-gradient(to right, #409EFF, #36D1DC);
    border-radius: 2px;
  }

  .section-header {
    text-align: center;
    margin-bottom: 80px;
    
    h2 {
      font-size: 2.8rem;
      color: #2c3e50;
      margin-bottom: 15px;
      font-weight: 700;
      letter-spacing: 2px;
      position: relative;
      padding-bottom: 25px;

      &::after {
        content: 'OUR ADVANTAGES';
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        font-size: 1rem;
        font-weight: 500;
        color: #0d1217;
        letter-spacing: 3px;
      }
    }
    
    p {
      font-size: 1.4rem;
      color:#0d1217;
      letter-spacing: 1px;
    }
  }

  .features-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 40px;
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 4vw;
  }

  .feature-card {
    background: white;
    padding: 40px 30px;
    border-radius: 15px;
    text-align: center;
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
    position: relative;
    overflow: hidden;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(135deg, rgba(64, 158, 255, 0.1), rgba(54, 209, 220, 0.1));
      opacity: 0;
      transition: opacity 0.4s ease;
    }

    &:hover {
      transform: translateY(-10px);
      box-shadow: 0 20px 40px rgba(64, 158, 255, 0.15);

      &::before {
        opacity: 1;
      }

      .feature-icon {
        transform: rotateY(360deg);
        background: linear-gradient(135deg, #409EFF, #36D1DC);

        img {
          filter: brightness(0) invert(1);
        }
      }

      h3 {
        color: #409EFF;
      }
    }

    .feature-icon {
      width: 90px;
      height: 90px;
      margin: 0 auto 30px;
      background: #f8f9fa;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);
      box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);

      img {
        width: 45px;
        height: 45px;
        transition: all 0.6s ease;
      }
    }

    h3 {
      font-size: 1.4rem;
      color: #2c3e50;
      margin-bottom: 20px;
      font-weight: 600;
      transition: color 0.3s ease;
    }

    p {
      color: #0d1217;
      line-height: 1.8;
      font-size: 1.05rem;
      margin: 0;
    }
  }

  @media (max-width: 1200px) {
    .features-grid {
      grid-template-columns: repeat(2, 1fr);
      gap: 30px;
    }
  }

  @media (max-width: 768px) {
    padding: 60px 0;

    .section-header {
      margin-bottom: 50px;

      h2 {
        font-size: 2.2rem;
      }

      p {
        font-size: 1rem;
      }
    }

    .features-grid {
      grid-template-columns: 1fr;
      gap: 25px;
      padding: 0 20px;
    }

    .feature-card {
      padding: 30px 20px;

      .feature-icon {
        width: 80px;
        height: 80px;
        margin-bottom: 20px;

        img {
          width: 40px;
          height: 40px;
        }
      }

      h3 {
        font-size: 1.3rem;
        margin-bottom: 15px;
      }

      p {
        font-size: 0.95rem;
      }
    }
  }
}

// About Section
.about-section {
  padding: 100px 0;

  .about-content {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 60px;
    align-items: center;
  }

  .about-image {
    img {
      width: 100%;
      border-radius: 10px;
      box-shadow: 0 5px 15px rgba(0,0,0,0.1);
    }
  }

  .about-text {
    h2 {
      font-size: 2.5rem;
      color: #2c3e50;
      margin-bottom: 30px;
    }

    .about-description {
      color: #666;
      line-height: 1.8;
      margin-bottom: 30px;

      p {
        margin-bottom: 15px;
      }
    }
  }
}

// Services Section
.service-section {
  padding: 4rem 0;
  background: #fff;

  .section-header {
    text-align: center;
    margin-bottom: 3rem;

    h2 {
      font-size: 2.2rem;
      color: #2c3e50;
      margin-bottom: 0.5rem;
      font-weight: 600;
    }

    p {
      font-size: 1rem;
      color: #0d1217;
      letter-spacing: 0.2rem;
    }
  }

  .service-grid {
    max-width: 1400px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 2rem;
    padding: 0 2rem;
  }

  .service-card {
    background: white;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.06);
    cursor: pointer;
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    border: 1px solid #f0f0f0;

    &:hover {
      transform: translateY(-6px);
      box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
      border-color: #e6e6e6;

      .card-image {
        img {
          transform: scale(1.05);
        }

        .card-overlay {
          opacity: 1;
          
          .overlay-content {
            transform: translateY(0);
            opacity: 1;
          }
        }
      }

      .card-content {
        background: #f8f9fa;

        .card-line {
          width: 40%;
        }

        h3 {
          color: #409EFF;
        }
      }
    }

    .card-image {
      height: 220px;
      position: relative;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: all 0.4s ease;
      }

      .card-overlay {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(to top, rgba(64, 158, 255, 0.9), rgba(64, 158, 255, 0.7));
        opacity: 0;
        transition: all 0.4s ease;
        display: flex;
        align-items: center;
        justify-content: center;

        .overlay-content {
          text-align: center;
          color: white;
          transform: translateY(20px);
          opacity: 0;
          transition: all 0.4s ease;
          padding: 0 1rem;

          h3 {
            font-size: 1.4rem;
            margin-bottom: 1rem;
            font-weight: 500;
          }

          .view-more {
            display: inline-block;
            padding: 0.6rem 1.5rem;
            border: 2px solid white;
            border-radius: 25px;
            font-size: 0.9rem;
            transition: all 0.3s ease;

            &:hover {
              background: white;
              color: #409EFF;
            }
          }
        }
      }
    }

    .card-content {
      padding: 1.5rem;
      background: white;
      transition: all 0.3s ease;
      text-align: center;

      h3 {
        font-size: 1.2rem;
        color: #2c3e50;
        margin-bottom: 0.8rem;
        font-weight: 500;
        transition: all 0.3s ease;
      }

      .card-line {
        width: 30px;
        height: 2px;
        background: #409EFF;
        margin: 0.5rem auto;
        transition: all 0.4s ease;
      }

      .card-description {
        color: #666;
        font-size: 0.9rem;
        line-height: 1.6;
        margin: 0;
        max-height: 3em;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        text-overflow: ellipsis;

        :deep(p) {
          margin: 0;
        }
      }
    }
  }

  .view-all {
    text-align: center;
    margin-top: 3rem;

    .view-all-btn {
      display: inline-block;
      padding: 0.8rem 2rem;
      background: #409EFF;
      color: white;
      border-radius: 30px;
      text-decoration: none;
      font-size: 1rem;
      transition: all 0.3s ease;
      box-shadow: 0 4px 15px rgba(64, 158, 255, 0.2);

      &:hover {
        background: #66b1ff;
        transform: translateY(-2px);
        box-shadow: 0 8px 20px rgba(64, 158, 255, 0.3);
      }
    }
  }

  @media (max-width: 1200px) {
    .service-grid {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  @media (max-width: 768px) {
    padding: 3rem 0;

    .section-header {
      margin-bottom: 2rem;

      h2 {
        font-size: 1.8rem;
      }

      p {
        font-size: 0.9rem;
      }
    }

    .service-grid {
      grid-template-columns: 1fr;
      gap: 1.5rem;
      padding: 0 1rem;
    }

    .service-card {
      .card-image {
        height: 180px;
      }

      .card-content {
        padding: 1.2rem;

        h3 {
          font-size: 1.1rem;
        }

        .card-description {
          font-size: 0.85rem;
        }
      }
    }
  }
}

// Statistics Section
.stats-section {
  padding: 60px 0;
  background: linear-gradient(135deg, #409EFF, #36D1DC);
  color: white;

  .section-container {
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 20px;
  }

  .stats-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 40px;
    text-align: center;
  }

  .stat-item {
    background: rgba(255, 255, 255, 0.1);
    padding: 30px 20px;
    border-radius: 15px;
    backdrop-filter: blur(10px);
    transition: transform 0.3s ease;

    &:hover {
      transform: translateY(-5px);
    }

    h3 {
      font-size: 3rem;
      margin-bottom: 15px;
      font-weight: 600;
      background: linear-gradient(135deg, #fff, #e6e6e6);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      white-space: nowrap;
    }

    p {
      font-size: 1.2rem;
      opacity: 0.9;
      white-space: nowrap;
      color: #fff;
    }
  }

  @media (max-width: 1024px) {
    padding: 50px 0;

    .stats-grid {
      grid-template-columns: repeat(2, 1fr);
      gap: 30px;
      padding: 0 20px;
    }

    .stat-item {
      padding: 25px 15px;

      h3 {
        font-size: 2.5rem;
        margin-bottom: 10px;
      }

      p {
        font-size: 1.1rem;
      }
    }
  }

  @media (max-width: 480px) {
    padding: 40px 0;

    .section-container {
      padding: 0 15px;
    }

    .stats-grid {
      grid-template-columns: 1fr;
      gap: 20px;
      padding: 0;
    }

    .stat-item {
      padding: 20px 15px;
      max-width: 280px;
      margin: 0 auto;
      background: rgba(255, 255, 255, 0.15);

      h3 {
        font-size: 2.2rem;
        margin-bottom: 8px;
      }

      p {
        font-size: 1rem;
      }
    }
  }
}

// Contact Section 新样式
.contact-section {
  padding: 80px 0;
  background: #f8f9fa;

  .section-header {
    text-align: center;
    margin-bottom: 60px;

    h2 {
      font-size: 2.5rem;
      color: #2c3e50;
      margin-bottom: 15px;
    }

    p {
      font-size: 1.2rem;
      color: #0d1217;
    }
  }

  .contact-content {
    display: flex;
    justify-content: space-between;
    gap: 40px;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;

    @media (max-width: 768px) {
      flex-direction: column;
    }
  }

  .contact-info {
    flex: 1;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 30px;
  }

  .info-card {
    background: white;
    padding: 30px;
    border-radius: 10px;
    text-align: center;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    box-shadow: 0 5px 15px rgba(0,0,0,0.1);

    &:hover {
      transform: translateY(-5px);
      box-shadow: 0 8px 20px rgba(0,0,0,0.15);
    }

    .icon-box {
      width: 60px;
      height: 60px;
      margin: 0 auto 20px;
      background: #409EFF;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;

      i {
        font-size: 30px;
        color: white;
      }
    }

    h3 {
      font-size: 1.3rem;
      color: #2c3e50;
      margin-bottom: 15px;
    }

    p {
      color: #666;
      line-height: 1.6;
      margin-bottom: 10px;
    }
  }

  .contact-btn {
    margin-top: 15px;
    padding: 10px 25px;
    background: #409EFF;
    color: white;
    border: none;
    border-radius: 5px;
    font-size: 1rem;
    cursor: pointer;
    transition: background 0.3s ease;

    &:hover {
      background: darken(#409EFF, 10%);
    }
  }
}

// Buttons
.primary-btn {
  padding: 15px 30px;
  background: #409EFF;
  color: white;
  border: none;
  border-radius: 5px;
  font-size: 1rem;
  cursor: pointer;
  transition: background 0.3s ease;

  &:hover {
    background: darken(#409EFF, 10%);
  }
}

.outline-btn {
  padding: 15px 30px;
  background: transparent;
  color: white;
  border: 2px solid white;
  border-radius: 5px;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: white;
    color: #409EFF;
  }
}

.text-btn {
  background: none;
  border: none;
  color: #409EFF;
  font-size: 1rem;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  gap: 5px;

  &:hover {
    text-decoration: underline;
  }
}

// Animations
@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

// Responsive Design
@media (max-width: 1024px) {
  .hero-section {
    .hero-overlay {
      .hero-title {
        font-size: 2.5rem;
      }
      .hero-subtitle {
        font-size: 1.2rem;
      }
    }
  }

  .about-section, .contact-section {
    .about-content, .contact-content {
      grid-template-columns: 1fr;
      gap: 40px;
    }
  }
}

@media (max-width: 768px) {
  .section-header {
    h2 {
      font-size: 2rem;
    }
  }

  .features-section, .service-section {
    .features-grid, .service-grid {
      grid-template-columns: 1fr;
    }
  }

  .stats-section {
    .stats-grid {
      grid-template-columns: repeat(2, 1fr);
    }
  }
}

// Add back the original about us (company-history) styles
.company-history {
  text-align: center;
  margin: 0 auto;
  padding: 80px 0;
  width: 100%;
  background: linear-gradient(to bottom, #f8f9fa, #ffffff);
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 60px;
    height: 3px;
    background: linear-gradient(to right, #409EFF, #36D1DC);
    border-radius: 2px;
  }

  .history-container {
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 4vw;
    display: flex;
    justify-content: space-between;
    flex-wrap: nowrap;
    gap: 6vw;
    align-items: center;
  }

  .history-left {
    width: 40%;
    height: 450px;
    transition: all 0.3s ease;
    box-shadow: 0 10px 30px rgba(0,0,0,0.08);
    border-radius: 15px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff;
    transform: translateY(0);

    img {
      pointer-events: none;
      width: 100%;
      height: 100%;
      object-fit: contain;
      padding: 30px;
      transition: transform 0.5s cubic-bezier(0.4, 0, 0.2, 1);
    }

    &:hover {
      transform: translateY(-10px);
      box-shadow: 0 15px 40px rgba(64, 158, 255, 0.15);
      
      img {
        transform: scale(1.05);
      }
    }
  }

  .history-right {
    width: 50%;
    height: auto;
    padding: 2vw;
    display: flex;
    flex-direction: column;
    justify-content: center;
    animation: fadeInRight 1s ease-out;
  }

  .more {
    width: 140px;
    border: 2px solid #409EFF;
    height: 45px;
    text-align: center;
    line-height: 43px;
    margin-left: 0;
    transform: none;
    margin-top: 3vw;
    color: #409EFF;
    cursor: pointer;
    transition: all 0.3s ease;
    border-radius: 25px;
    font-weight: 500;
    position: relative;
    overflow: hidden;
    z-index: 1;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 0;
      height: 100%;
      background: #409EFF;
      transition: all 0.3s ease;
      z-index: -1;
    }

    &:hover {
      color: white;
      box-shadow: 0 5px 15px rgba(64, 158, 255, 0.3);

      &::before {
        width: 100%;
      }
    }
  }

  .history-h3 {
    font-size: 2.8rem !important;
    font-weight: 700;
    letter-spacing: 2px;
    color: #0d1217;
    margin-bottom: 1vw;
    text-align: left;
    position: relative;
    padding-bottom: 25px;

    &::after {
      content: 'ABOUT US';
      position: absolute;
      bottom: 0;
      transform: translateX(40%);
      left: 0;
      font-size: 1rem;
      font-weight: 500;
      color: #0d1217;
      letter-spacing: 3px;
    }
  }

  .history-p {
    font-family: 正体 !important;
    font-weight: 400;
    line-height: 1.8;
    font-size: 1.3rem;
    color: #2c3e50;
    text-align: left;
    letter-spacing: 0.5px;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-top: 2vw;
  }
}

@keyframes fadeInRight {
  from {
    opacity: 0;
    transform: translateX(30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

// 响应式调整
@media (max-width: 1024px) {
  .company-history {
    padding: 60px 0;

    .history-container {
      flex-direction: column;
      align-items: center;
      gap: 40px;
      padding: 20px;
    }

    .history-left {
      width: 100%;
      max-width: 500px;
      height: 300px;
    }

    .history-right {
      width: 100%;
      max-width: 800px;
      padding: 0;
      text-align: center;

      .history-h3 {
        text-align: center;
        font-size: 2.2rem !important;

        &::after {
          left: 50%;
          transform: translateX(-50%);
        }
      }

      .more {
        margin: 3vw auto 0;
      }
    }
  }
}
</style>

<script>
import ContactUs from "@/components/ContactUs.vue";

export default {
  name: "Index",
  components: {
    ContactUs
  },
  data() {
    return {
      showOverlay: [],
      busBool: [],
      honorList: [],
      honorImg: "",
      swiperList: [
        { img: require("@/assets/img1/首页海报3.png") },
      ],
      companyCultureList: [
        {
          img: require("@/assets/img1/4.png"),
          subtilte: "资质齐全",
          text: "具备完整齐全资质，质量保障",
        },
        {
          img: require("@/assets/img1/3.png"),
          subtilte: "质量保障",
          text: "优先优良配件，产品质量有保障",
        },
        {
          img: require("@/assets/img1/2.png"),
          subtilte: "价格实惠",
          text: "提供专业价格类目，公道放心",
        },
        {
          img: require("@/assets/img1/5.png"),
          subtilte: "高效服务",
          text: "快速响应需求，高效处理流程，提升工作效率",
        },
        {
          img: require("@/assets/img1/6.png"),
          subtilte: "经验丰富",
          text: "专注造就专业，铸造实力企业",
        },
        {
          img: require("@/assets/img1/1.png"),
          subtilte: "售后保障",
          text: "专业及时的售后服务，让您无后顾之忧",
        },
      ],
      swiper2List: [
        {
          img: require("@/assets/img1/首页海报1.jpg"),
          title: "深圳市达通源科技有限公司",
          text: "深圳市达通源科技有限公司，简称DTY，是国家认可的第三方检测机构。",
        },
        {
          img: require("@/assets/img1/首页海报2.png"),
          title: "水平衡测试",
          text: "水平衡测试是对用水单元或系统的水量进行系统地测量、统计和计算，根据水量平衡原理进行分析。",
        },
        {
          img: require("@/assets/img1/首页海报3.png"),
          title: "节能环保服务",
          text: "提供专业的节能环保解决方案，助力企业实现可持续发展。",
        },
      ],
      services: []
    };
  },
  mounted() {
    this.setupIntersectionObserver();
    var mySwiper = new Swiper(".swiper-container", {
      loop: true,
      autoplay: false,
      allowTouchMove: false,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
    this.loadServices();
  },
  methods: {
    scrollDown() {
      window.scrollBy({
        top: 1200,
        behavior: 'smooth'
      });
    },
    setupIntersectionObserver() {
      const options = {
        root: null,
        threshold: 0.1
      };

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('fade-in');
            observer.unobserve(entry.target);
          }
        });
      }, options);

      observer.observe(this.$refs.fadeEnlarge);
    },
    clickGoin() {
      this.$router.push({ name: "goin" });
    },
    learnMore(index) {
      // 根据需要实现具体的跳转逻辑
      console.log('Learn more about:', this.swiper2List[index].title);
    },
    handleContact() {
      window.location.href = "tel:0755-88608260";
    },
    showContactDialog() {
      this.$refs.contactUs.showDialogVisible();
    },
    loadServices() {
      this.$http
        .get(`business/page?pageNo=1&pageSize=3&first=1`)
        .then(response => {
          this.services = response.data.data.list;
          for (let service of this.services) {
            service.filePath = this.imgserver + service.filePath;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    routeLink(id) {
      this.$router.push({ name: "Tabe", query: { id: id }});
    },
    getShortDescription(description) {
      if (!description) return '专业服务，品质保证';
      
      const div = document.createElement('div');
      div.innerHTML = description;
      const text = div.textContent || div.innerText;
      
      return text.length > 50 ? text.slice(0, 50) + '...' : text;
    },
    formatCreateTime(timestamp) {
      const date = new Date(timestamp);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}/${month}/${day}`;
    }
  }
};
</script>
